const trimTrailingSlash = (value) => value.replace(/\/+$/, '')

const requiredEnv = (name) => {
  const value = process.env[name]
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`)
  }
  return value
}

export const API_BASE_URL = trimTrailingSlash(requiredEnv('VUE_APP_API_BASE_URL'))

export const PUBLIC_APP_URL = trimTrailingSlash(requiredEnv('VUE_APP_PUBLIC_APP_URL'))

export const SHARE_META_PATH = requiredEnv('VUE_APP_SHARE_META_PATH')

export const FLAGS_CDN_URL = trimTrailingSlash(requiredEnv('VUE_APP_FLAGS_CDN_URL'))

export const shareMetaUrl = (locale) => `${PUBLIC_APP_URL}${SHARE_META_PATH}_${locale}.php`
